import { render } from "./ShareAndEarn.vue?vue&type=template&id=6e3a6d04"
import script from "./ShareAndEarn.vue?vue&type=script&lang=ts"
export * from "./ShareAndEarn.vue?vue&type=script&lang=ts"
script.render = render

export default script